import { useEffect } from 'react';
import { createSearchParams, NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import Plan from './components/Plan'

function Planskoodo() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly', marginBottom: 10, alignItems: 'center', width: '100%', height: '100%' }}>
      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}><NavLink to="/carrier"><FontAwesomeIcon style={{ position: "absolute", marginLeft: 10, marginTop: 25, color: '#663399' }} icon={faArrowLeft} className="fa-2xl" /></NavLink><div style={{ width: '100%' }}><h1 style={{ justifySelf: "center", borderBottom: '1px solid #e6e6e6', margin: "0px", padding: "20px" }}>Please choose a koodo plan</h1></div></div>
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBottom: 10, alignItems: 'center', width: '100%', height: '100%' }}>
        <Plan carrier='Koodo' planName='29$' planData='20GB' planInfo='Unlimited Canada-Wide Talk and Data at speeds up to 150 Mbps' planPromo='Promo: 10GB Extra For 24 Months' />
      </div>
    </div>
  );
}

export default Planskoodo;
